import { type UseMutationResult, useMutation, useQueryClient } from 'react-query';
import { toast } from 'react-toastify';
import ToastComponent from '../../components/toast';
import {
  AdvisorPartnerEnrollmentConfigService,
  type Wealthlane_Dtos_AdvisorApi_AdvisorPartnerEnrollmentConfigDto,
  type Wealthlane_Dtos_AdvisorApi_UpsertAdvisorPartnerEnrollmentConfigDto,
} from '@wealthlane/api-services/wealthlane-identity-service';

const useUpsertAdvisorPartnerEnrollmentConfig = (
  handleRequest: <T>(request: Promise<T>) => Promise<T | undefined>,
  successMessage = 'Advisor enrollment settings saved successfully.',
): UseMutationResult<
  Wealthlane_Dtos_AdvisorApi_AdvisorPartnerEnrollmentConfigDto | undefined,
  unknown,
  Wealthlane_Dtos_AdvisorApi_UpsertAdvisorPartnerEnrollmentConfigDto,
  unknown
> => {
  const queryClient = useQueryClient();

  return useMutation(
    async (payload) => {
      return await handleRequest(
        AdvisorPartnerEnrollmentConfigService.postApiIdentityApiAppAdvisorPartnerEnrollmentConfigUpsert(
          payload,
        ),
      );
    },
    {
      onSuccess: (data) => {
        if (data != null) {
          void queryClient.invalidateQueries('getAdvisorPartnerEnrollmentConfig');
          toast.success(<ToastComponent label='Success' message={successMessage} />);
        }
      },
    },
  );
};

export default useUpsertAdvisorPartnerEnrollmentConfig;
